import { Injectable } from '@angular/core';
import { IDocumentResult } from '../../models/ocr';

@Injectable({
	providedIn: 'root',
})
export class ScoringDocumentService {
	private validationDocument: Array<IDocumentResult> = [];

	// Porcentaje de tiempo en medio
	public getPercentageTimeInMiddle(results: Array<IDocumentResult>): number {
		if (!results.length) return 0;
		const detectedCount = results.filter((r: IDocumentResult) => r.detected === true).length;
		const result = (detectedCount * 100) / results.length;
		return result;
	}

	// Porcentaje de emocion superior al de la prueba
	public getPercentageDocument(results: Array<IDocumentResult>): number {
		if (results.length) {
			const scoreArray: Array<number> = results.map((r: IDocumentResult) => r.score);
			const result = (scoreArray.reduce((sum, num) => sum + num, 0) / scoreArray.length) * 100;
			return result;
		}
		return 0;
	}

	// Validación
	public getDocumentValidation(): Array<IDocumentResult> {
		return this.validationDocument;
	}

	public setDocumentValidation(value: Array<IDocumentResult>): void {
		this.validationDocument = value;
	}

	public addDocumentValidation(value: IDocumentResult): void {
		this.validationDocument.push(value);
	}
}
